<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="columns onboarding-create-site__step7">
    <div
      class="column is-5 onboarding-create-site__img onboarding-create-site__img--step7 is-hidden-mobile"
      :style="`background-image: url(${imgNoivosFeliz})`"
    ></div>
    <div
      class="column has-text-centered onboarding-create-site__description onboarding-create-site__description--step7"
    >
      <div class="onboarding-create-site__description--width-80">
        <h1 class="onboarding-create-site__title has-text-weight-bold">
          E quais presentes virtuais vocês gostariam de exibir em sua lista de
          casamento?
        </h1>
        <p class="onboarding-create-site__paragraph">
          Todos os presentes serão recebidos em dinheiro
        </p>
        <AnswersSquare :options="options" :rectangle="rectangle" />
      </div>
      <buttonsNext :stepNumber="stepNumber" />
    </div>
  </div>
</template>

<script>
import verifyOnboardingCompleteMixin from '@/mixins/verifyOnboardingCompleteMixin'

import buttonsNext from '@/components/OnboardingCreationSite/ButtonsNext.vue'
import AnswersSquare from '@/components/OnboardingCreationSite/OptionsAnswersSquare.vue'
import imgNoivosFeliz from '@/assets/img/onboarding-create-site/casal-montanha.jpg'

export default {
  mixins: [verifyOnboardingCompleteMixin],

  components: {
    buttonsNext,
    AnswersSquare,
  },

  props: {
    stepNumber: Number,
  },

  computed: {
    step: {
      get() {
        return this.$store.state.onboardingCreateSite.step
      },
      set(payload) {
        this.$store.dispatch('setStep', payload)
      },
    },
  },

  data() {
    return {
      imgNoivosFeliz,
      rectangle: 'onboarding-create-site__options-answers-square-rectangle',
      options: [
        {
          id: 0,
          icon: '🏖',
          text: 'Viagens e experiências de lua de mel',
          value: 'viagem',
        },
        {
          id: 1,
          icon: '🍳',
          text: 'Produtos para casa',
          value: 'casa',
        },
        {
          id: 2,
          icon: '🎊',
          text: 'Geral de casamento (Lua de mel + Produtos para casa)',
          value: 'geral',
        },
        {
          id: 3,
          icon: '🤪',
          text: 'Presentes divertidos',
          value: 'divertida',
        },
        {
          id: 4,
          icon: '✏️',
          text: 'Personalizar do nosso jeito',
          value: 'personalizada',
        },
      ],
    }
  },
}
</script>

<style lang="scss">
.onboarding-create-site {
  &__step7 {
    display: flex;
    min-height: fit-content;
  }

  &__img {
    &--step7 {
      margin-top: 12px;
    }
  }

  &__description {
    &--step7 {
      min-height: calc(100vh - 56px);
    }
  }
}
</style>
